<template>
  <div class="page-container">
    <sub-header>
      <template slot="title">{{$route.meta.title}}
      </template>
      <template slot="btn">
        <el-button type="primary"
                   @click="openLaborGroupDialog"
                   v-has="'Create Report'"
                   size="medium">{{$t('labor.Add Labor Group')}}</el-button>
      </template>
      <template slot="search">
        <el-row :gutter="20">
          <el-col :lg="8"
                  :md="6">
            <el-input size="mini"
                      :placeholder="$t('labor.SearchLaborName')"
                      @change="GetProjectLaborGroups"
                      v-model="condition.Name"
                      clearable></el-input>
          </el-col>
        </el-row>
      </template>
    </sub-header>
    <div class="main">
      <div class="table-box">
        <myScroll style="width:100%;height:100%">
          <el-table :data="list"
                    size="small"
                    @row-click="toLaborDetail">
            <el-table-column :label="$t('labor.Name')">
              <template slot-scope="scope">
                <el-button type="text">
                  {{scope.row.Name}}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column :label="$t('labor.Trades')">
              <template slot-scope="scope">
                <span>{{scope.row.TradesStr}}</span>
              </template>

            </el-table-column>
            <el-table-column :label="$t('labor.Retainage')"
                             width="120px">
              <template slot-scope="scope">
                {{scope.row.RetainageRate}}%
              </template>
            </el-table-column>
            <el-table-column :label="$t('labor.Time Ranges:')">
              <template slot-scope="scope">
                {{scope.row.TimeRange}}
              </template>
            </el-table-column>
          </el-table>
        </myScroll>
      </div>
      <page :total="total"
            :PageSize="condition.PageSize"
            :PageIndex="condition.PageIndex"
            @handleCurrentChange="handleCurrentChange"></page>
    </div>
    <laborGroupDialog :showDialog="laborGroupDialog.showDialog"
                      :editForm="laborGroupDialog.editForm"
                      @closeDialog="closeLaborGroupDialog"></laborGroupDialog>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import laborGroupDialog from '@/components/labor/laborGroupDialog.vue'
import {
  GetProjectLaborGroups
} from '@/api/config'
export default {
  components: {
    laborGroupDialog
  },
  data () {
    return {
      laborGroupDialog: {
        showDialog: false,
        editForm: {}
      },
      condition: {
        JobsiteId: '',
        Name: '',
        PageIndex: 1,
        PageSize: 10
      },
      list: [],
      total: 0
    }
  },
  created () {

  },
  computed: {
    ...mapState(['jobsiteID'])
  },
  watch: {

  },
  mounted () {
    this.GetProjectLaborGroups()
  },
  methods: {
    openLaborGroupDialog () {
      this.laborGroupDialog.editForm = {
        Trades: ['OPTION_ALL']
      }
      this.laborGroupDialog.showDialog = true
    },
    closeLaborGroupDialog () {
      this.GetProjectLaborGroups()
      this.laborGroupDialog.showDialog = false
    },
    toLaborDetail (row) {
      this.$router.push({
        name: 'labor',
        params: {
          laborGroupId: row.LaborGroupId
        }
      })
    },
    handleCurrentChange (val) {
      this.condition.PageIndex = val
      this.GetProjectLaborGroups()
    },
    GetProjectLaborGroups () {
      this.condition.JobsiteId = this.jobsiteID
      GetProjectLaborGroups(this.condition).then(res => {
        this.list = res.Data
        this.list.forEach(ele => {
          ele.ApplicationDate = this.$config.LocalTime(ele.ApplicationDate)
          ele.StartDate = this.$config.LocalTime(ele.StartDate)
          ele.EndDate = this.$config.LocalTime(ele.EndDate)
          ele.showDate = moment(ele.ApplicationDate).format('MM/DD/yyyy hh:mm:ss')
          ele.showStartDate = moment(ele.StartDate).format('MM/DD/yyyy hh:mm:ss')
          ele.showEndDate = moment(ele.EndDate).format('MM/DD/yyyy hh:mm:ss')
          ele.TimeRange = ele.showStartDate.substring(0, 10) + ' - ' + ele.showEndDate.substring(0, 10)
          ele.RetainageRate = this.$config.multiply(ele.RetainageRate, 100)
          ele.TradesStr = ele.Trades.join(', ')
          if (ele.TradesStr === 'OPTION_ALL') {
            ele.TradesStr = this.$t('labor.All')
          }
        })
        this.total = res.TotalCount
      })
    }
  }
}
</script>

<style scoped lang="scss">
.table-box {
  flex: 1;
  height: 0;
  margin: 0 8px;
  border: 1px solid #dcdfe6;
}
</style>
